import { Component, OnInit } from '@angular/core';
import { ApiService } from '../api.service';
import { HandlerService } from '../handler.service';
import { PdfService } from '../pdf.service';
import { Router } from '@angular/router';
import { PaymentService } from '../payment.service';
import { TranslateService } from '@ngx-translate/core';
import { AuthService } from '../auth.service';
import { LocationService } from '../location.service';
import { MatBottomSheet } from '@angular/material/bottom-sheet';
import { BottomSheet } from '../bottom.sheet';
import { kill } from 'process';

let k = 1, j = 90;

@Component({
    selector: 'app-manage-user',
    templateUrl: './manage-user.component.html',
    styleUrls: ['./manage-user.component.scss'],
})
export class ManageUserComponent {
    timer: any;
    loader: boolean = false;
    users;
    userName;
    id;
    pageEnd: boolean = false;
    userLoader: boolean = false;
    scrollOne: boolean = true;
    type;
    search;
    cloneUsers;
    contactNbrMob;
    Uid;
    tagRole: boolean;
    empty: boolean = false;
    active: boolean = false;
    close: boolean = false;
    dupUsers: any;
    userCredits: any;
    userCreditsView: boolean = false;
    orgs: any = [];
    orgName;
    orgId;
    header;
    scrollResponse: any;
    roleObj = [{ id: 1, name: "SERVICE PROVIDER", code: "SP" },
    { id: 0, name: "SERVICE CONTRACTOR", code: "SC" }, { id: 2, name: "SUPERVISOR", code: "SPVR" }, {
        id: 3,
        name: "Vendor Manager",
        code: "VM"
    }, { id: 4, name: "Customer Request Handler", code: "CUSTRQH" }, {
        id: 5,
        name: "Customer Support",
        code: "CUSTSUP"
    }]
    roleName;
    code: any;
    roleId;
    roleOtherObj = [{ id: 1, name: "SERVICE PROVIDER", code: "SP" },
    { id: 0, name: "SERVICE CONTRACTOR", code: "SC" }, { id: 2, name: "SUPERVISOR", code: "SPVR" }]

    constructor(private service: ApiService,
        public handler: HandlerService,
        public pdf: PdfService,
        public bottomSheet: MatBottomSheet,
        public router: Router,
        public payment: PaymentService,
        public translate: TranslateService,
        public auth: AuthService, public location: LocationService) {
    }

    ionViewWillEnter() {
        sessionStorage.setItem('vendorApp', 'true');
        this.id = localStorage.getItem('organizationId');
        this.loader = true;
        let y = JSON.parse(localStorage.getItem('capabilityOrg')).find(res => res.id == this.id);
        this.orgName = y.name;
        sessionStorage.setItem("orgCd", y.code);
        sessionStorage.setItem("orgId", this.id)
        if (y.id == this.id) {
            this.tagRole = true;
        }
        this.roleName = this.roleObj[1].name;
        this.code = this.roleObj[1].code;
        this.roleId = this.roleObj[1].id;
        k = 1;
        this.getsc();
        this.getOrgs();

    }

    getUsers(val) {
        //this method waits for the user to finish typing and then triggers the call
        clearTimeout(this.timer);
        this.timer = setTimeout(() => {
          console.log(val);
          this.getUser(val);
        }, 500);
      }

    getUser(val) {
        this.empty = false;
        let x = val.length;
        if (x >= 3) {
            this.close = true;
            this.service.searchCustomers("SC", val, this.id).subscribe((res: any) => {
                if (!this.empty) {
                    this.cloneUsers = JSON.parse(JSON.stringify(res));
                    this.users = JSON.parse(JSON.stringify(res));
                    if (x == 0) {
                        this.cloneUsers = []
                    }
                    // this.users= this.users.filter(res =>{return res.verified == true})
                } else {
                    this.cloneUsers = [];
                    this.close = false;
                    this.users = [];
                    this.empty = true;
                }
            })
        } else {
            this.close = false;
            this.empty = true;
            this.users = this.dupUsers
        }
    }

    get(id) {
        sessionStorage.setItem('roleId', this.code)
        this.router.navigate(['vendorProfile1/', +id])
    }


    async onPageScroll($event) {
        const scrollElement = await $event.target.getScrollElement();
        const scrollHeight = scrollElement.scrollHeight - scrollElement.clientHeight;
        const currentScrollDepth = $event.detail.scrollTop;
        const targetPercent = j;
        let triggerDepth = ((scrollHeight / 100) * targetPercent);
        if (currentScrollDepth > triggerDepth) {
            if (!this.active) {
                this.getsc()

            }
            k++;
        }

    }

    booking(id) {
        this.router.navigate(['userRequest/', +id])
    }


    ionViewWillLeave() {
        this.search = "";
        this.userName = "";
        this.cloneUsers = "";
    }

    getOrgs() {
        this.service.getOrg().subscribe((res: any) => {
            this.orgs = res;
        })
    }

    roles(id) {
        this.router.navigate(['/tag-role', id]);
    }

    openBottomSheet(): void {
        const dialogRef = this.bottomSheet.open(BottomSheet, {
            data: this.orgs,
        });
        dialogRef.afterDismissed().subscribe((res: any) => {
            this.orgName = res.name;
            this.id = res.id;
            sessionStorage.setItem("orgCd", res.code);
            sessionStorage.setItem("orgId", this.id);
            this.getsc()
        });
    }


    openBottomSheetRole() {
        if (sessionStorage.getItem('orgId') == '790') {
            const dialogRef = this.bottomSheet.open(BottomSheet, {
                data: this.roleObj,
            });
            dialogRef.afterDismissed().subscribe((res: any) => {
                this.roleName = res.name;
                this.code = res.code;
                this.roleId = res.id
                this.getsc()
            });
        } else {
            const dialogRef = this.bottomSheet.open(BottomSheet, {
                data: this.roleOtherObj,
            });
            dialogRef.afterDismissed().subscribe((res: any) => {
                this.roleName = res.name;
                this.code = res.code;
                this.roleId = res.id
                this.getsc()
            });
        }
    }

    routingPage() {
        if (this.roleId == 1) {
            this.router.navigate(['/provider-category']);
        } else if (this.roleId == 2) {
            this.router.navigate(['/supervisor-category']);
        } else if (this.roleId == 3) {
            this.router.navigate(['/manager-category'])
        } else if (this.roleId == 3) {
            this.router.navigate(['/manager-category'])
        } else if (this.roleId == 4) {
            this.router.navigate(['/cust-Req-category'])
        } else if (this.roleId == 5) {
            this.router.navigate(['/cust-care-category'])
        } else {
            this.router.navigate(['/employee-category']);
        }
    }

    refreshData(event) {
        this.loader = true;
        this.ionViewWillEnter();
        setTimeout(() => {
            event.target.complete();
        }, 1000);
    }

    clear() {
        this.userName = "";
        this.ionViewWillEnter();
        this.close = false;
    }

    vendorFilter() {
        this.loader = true;
        this.router.navigate(['/vendor-filter'])
    }



    getUserByPages() {
        this.loader = true;
        this.service.getUsersByOrg(this.code, this.id, k).subscribe((res: any) => {
            if (res) {
                this.users = res;

                if (res.userCredits) {
                    this.userCredits = res.userCredits[0].creditPoints;
                    this.userCreditsView = true;
                } else {
                    this.userCreditsView = false;
                }
                this.dupUsers = res;
                this.loader = false;
            } else {
                this.handler.res("No Data Found");
                this.loader = false;
                this.users = [];
                this.dupUsers = [];
            }
        }, err => {
            this.handler.err(err)
            this.loader = false;
        })
    }

    getsc() {
        this.loader = true;
        this.service.getUsersByOrg(this.code, this.id, k).subscribe((res: any) => {
            if (res) {
                this.users = res;

                if (res.userCredits) {
                    this.userCredits = res.userCredits[0].creditPoints;
                    this.userCreditsView = true;
                } else {
                    this.userCreditsView = false;
                }
                // this.users= this.users.filter(res =>{return res.verified == true})
                this.dupUsers = res;
                // this.dupUsers=this.dupUsers.filter(res =>{return res.verified == true});
                this.loader = false;
                k++;
            } else {
                this.handler.res("No Data Found");
                this.loader = false;
                this.users = [];
                this.dupUsers = [];
            }


        }, err => {
            this.handler.err(err)
            this.loader = false;
        })
    }


    onScroll($event) {
        console.log(k);
        this.pageEnd = true;
        if (this.scrollResponse) {
            this.scrollResponse.unsubscribe();
        }
        this.userLoader = false;
        if (!this.userLoader) {
            this.scrollResponse = this.service.getUsersByOrg(this.code, this.id, k).subscribe((res: any) => {
                if (res && res.length > 0) {
                    this.scrollOne = false;
                    this.userLoader = false;
                    res.map(dat => {
                        this.users.push(dat);
                        this.dupUsers.push(dat);
                        this.users = this.users.filter((x, i, a) => a.indexOf(x) == i);
                        this.dupUsers = this.dupUsers.filter((x, i, a) => a.indexOf(x) == i);
                    });
                    this.loader = false;
                    if (this.users && this.users.length > 0) {
                        this.users.sort(function (a, b) {
                            if (a.firstName != null && b.firstName != null) {
                                var nameA = a.firstName.toLowerCase(), nameB = b.firstName.toLowerCase();
                                if (nameA < nameB) {
                                    return -1;
                                }
                                if (nameA > nameB) {
                                    return 1;
                                }
                                return 0;
                            }
                        });
                        this.dupUsers.sort(function (a, b) {
                            if (a.firstName != null && b.firstName != null) {
                                var nameA = a.firstName.toLowerCase(), nameB = b.firstName.toLowerCase();
                                if (nameA < nameB) {
                                    return -1;
                                }
                                if (nameA > nameB) {
                                    return 1;
                                }
                                return 0;
                            }
                        });
                        k++;
                        setTimeout(() => {
                            this.pageEnd = false;
                        }, 4000);
                    }
                } else {
                    this.loader = false;
                    this.userLoader = false;
                    this.scrollOne = true;
                }
            }, err => {
                this.userLoader = false;
                this.scrollOne = true;
                this.pageEnd = false;
            })

        }

    }



}
